import { DeliveryProvider, OFFER_KIND, PaymentMethod } from '../../../../../services/exports/Constants';

export default {
  customer_info: {
    dummy_order: 'Comandă de test',
    ordered_at: 'Comandat la:',
  },
  delivery_info: {
    info: 'Info livrare:',
  },
  order_note: {
    label: 'Notă comandă:',
  },
  schedule_info: {
    pickup: 'Ridicare',
    delivery: 'Livrare',
    on_site: 'Comandă la masă',
    wish_time: 'Ora dorită:',
    confirmed_time: 'Ora confirmată:',
    driver_arrival_time: 'Ora de preluare de către șofer:',
    external_delivery: 'Comanda este livrată de un șofer extern de la {{carrier}}',
  },
  products: {
    item: 'Produs:',
  },
  discount_breakdown: {
    label: 'Reducere',
    [OFFER_KIND.PERCENTAGE_OFF_BY_MIN_SPEND_VALUE]: 'Reducere procentuală pe total aplicată',
    [OFFER_KIND.PERCENTAGE_OFF_BY_PRODUCTS]: 'Reducere procentuală pe produse aplicată',
    [OFFER_KIND.AMOUNT_OFF_BY_PRODUCTS]: 'Reducere fixă pe produse aplicată',
    [OFFER_KIND.AMOUNT_OFF_BY_MIN_SPEND_VALUE]: 'Reducere fixă pe total aplicată',
    [OFFER_KIND.BOGO]: 'Bogo aplicat',
    [OFFER_KIND.BOGO_HALF_PRICE]: 'Bogo la jumătate de preț aplicat',
    [OFFER_KIND.FREE_ITEM_BY_PRODUCTS]: 'Produs gratuit pe produse aplicat',
    [OFFER_KIND.FREE_ITEM_BY_MIN_SPEND_VALUE]: 'Produs gratuit pe total aplicat',
    GiftCard: 'Card cadou aplicat',
    Reward: 'Puncte de fidelitate aplicate',
    CashbackAccount: 'Puncte de fidelitate aplicate',
    PromoCodeComponent: 'Cod promoțional aplicat',
    Offer: 'Ofertă aplicată',
  },
  payment_breakdown: {
    price: 'Preț:',
    subtotal: 'Subtotal',
    delivery_fee: 'Taxă de livrare',
    tips: 'Bacșiș',
    processing_fee: 'Taxă serviciu online',
    payment_method_upcharge_fee: {
      [PaymentMethod.Paypal]: 'Taxă PayPal',
    },
    tax: 'Taxe',
    total: 'Total',
    paid_amount: 'Sumă plătită',
    order_not_paid: 'Comanda nu a fost încă plătită',
    order_paid_online: 'Deja plătit online',
    cash: 'Plată la față locului',
    this_is_not_an_invoice: 'Aceasta nu este o factură',
  },
  delivery_qr_code: {
    scan: 'Scanează și livrează cu Google Maps',
  },
  delivery_providers: {
    [DeliveryProvider.UberDrive]: 'Uber',
    [DeliveryProvider.FirstDelivery]: 'Uber',
    [DeliveryProvider.WoltDrive]: 'Wolt',
  },
};
